<template>
  <section class="mt-16">
    <v-breadcrumbs
        v-if="this.$root.$vuetify.theme.isDark"
        large
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>
      <v-breadcrumbs
        v-else
        :items="crumbs"
        divider="/"
        light
        :class="this.$root.$vuetify.theme.isDark ? 'primary--text pl-0' : 'pl-0'"
      ></v-breadcrumbs>

      <h1 class="primary--text">
        <v-icon color="primary">mdi-shield-account</v-icon> <span>{{$t('roles.crumb_add')}}</span>
      </h1>

      <div class="mt-16">
        <role method="create"></role>
      </div>
  </section>
</template>
<script>
import Role from '@/components/roles/Role'

export default {
  components: {
    Role
  },
  beforeCreate(){
    document.title = "Report Lake - " + this.$t('roles.crumb_add');
  },
  data: () => ({
    
  }),
  mounted(){

    if(!this.$root.session.hasPermission(["super", "roles.create"])) {
      this.$router.push('/admin');
    }

  },
  methods:{
  },
  computed: {
    crumbs: function() {
      return [
        {
          text: this.$t('menu.dashboard'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin',
          exact: true,
        },
        {
          text: this.$t('globals.definitions'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/settings/general',
          exact: true,
        },
        {
          text: this.$t('menu.roles_management'),
          disabled: false,
          to: '/' + this.$session.get('domain') + '/admin/accesses/roles',
          exact: true,
        },
        {
          text: this.$t('roles.crumb_add'),
          disabled: true,
          to: window.location.href,
          exact: true,
        },
      ];
    }
  }
};
</script>
